import { render, staticRenderFns } from "./mh-label-select.vue?vue&type=template&id=3b88185c&scoped=true"
import script from "./mh-label-select.vue?vue&type=script&lang=js"
export * from "./mh-label-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b88185c",
  null
  
)

export default component.exports